import { ReactNode } from 'react';

interface StringNodeGuardProps {
  children?: ReactNode;
  node?: ReactNode;
}

/**
 * Component that has 2 options:
 *   - If node is not string, simply renders it
 *   - If is string, render children instead
 *
 *  Useful for text based composition in which you need a default text styling but allow user to overwrite the node
 */
export function StringNodeGuard({ children, node }: StringNodeGuardProps): JSX.Element | null {
  return <>{typeof node !== 'string' ? node : children}</>;
}
